// removed by extract-text-webpack-plugin
module.exports = {"lesson-student-table":"lesson-student-table","title":"title","student-count":"student-count","icon-users":"icon-users","icon-tag":"icon-tag"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ClassDetail/StudentTable/StudentTable.scss
// module id = i/UM
// module chunks = 0